import { put, takeLatest, call } from 'redux-saga/effects';
import { setCommentsSuccess, setCommentsFailure } from '../reducers/commentsSlice';
import { fetchComments } from '../../service/fetchComments';

/**
 * worker saga upon being called by the watcher saga makes the appropriate API call
 * and set the response data for both success and failuer calls.
 */
export function* workerCommentsSaga({ payload }) {
    try {
        const response = yield call(fetchComments, [payload]);
        yield put(setCommentsSuccess(response));
    } catch (error) {
        yield put(setCommentsFailure(error.toString()))
    }
}

/**
* watcher saga - looks for the respective action dispatch. 
* First argument in the take/takeLatest/takeEvery is the action type and 
* the second argument is the worker saga function.
*/
function* commentsSaga() {
    yield takeLatest("comments/getComments", workerCommentsSaga);
}

export default commentsSaga;